import type { StylesConfig } from "react-select";

/**
 * The pop-up participants From/To field (design 2152:16775): the react-select
 * CONTROL is the boxed input itself. The shared Select always paints the
 * control through emotion (`sizedSelectStyles`), so container classes cannot
 * restyle it — this override, merged after the sized styles, is the only way
 * to reshape it (50px tall, 8px radius, shadow/xs, 14px left inset with the
 * value container's own 8px).
 */
export const PARTICIPANT_FIELD_STYLES: StylesConfig = {
  control: (base, state) => ({
    ...base,
    cursor: "pointer",
    minHeight: 50,
    height: 50,
    maxHeight: 50,
    borderColor: "#1C1D221A",
    borderRadius: 8,
    backgroundColor: state.isDisabled ? "rgba(28,29,34,0.040)" : "#fff",
    boxShadow: "0px 1px 2px 0px rgba(16,24,40,0.05)",
    boxSizing: "border-box",
    paddingLeft: 6
  })
};

export const FOOTER_PILL_STYLES: StylesConfig = {
  control: (base, state) => ({
    ...base,
    cursor: "pointer",
    minHeight: 32,
    borderColor: "#1C1D221A",
    borderRadius: 8,
    backgroundColor: state.isDisabled ? "rgba(28,29,34,0.040)" : "#fff",
    boxShadow: "0px 1px 2px 0px rgba(28,29,34,0.05)"
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 0 0 8px"
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 8px 0 4px"
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: 13,
    whiteSpace: "nowrap"
  })
};
